/** PRD §5 entrepreneur journey — mirrors backend `journey-steps.ts`. */
export const JOURNEY_STEP = {
  LANDING: 0,
  MAP: 1,
  ASSESSMENT: 2,
  PLANNING_INFO: 3,
  INTAKE_VENTURE: 4,
  INTAKE_CONTACT: 5,
  INTAKE_REVIEW: 6,
  CONSENT: 7,
} as const;

export type JourneyStep = (typeof JOURNEY_STEP)[keyof typeof JOURNEY_STEP];

export const JOURNEY_QUESTIONNAIRE_STEP_OFFSET = 1;

/** Index in the 6-step progress UI (0 = map … 5 = assessment/חיווי). */
export const JOURNEY_UI_STEP = {
  MAP: 0,
  VENTURE: 1,
  CONTACT: 2,
  REVIEW: 3,
  CONSENT: 4,
  ASSESSMENT: 5,
} as const;
